// extracted by css-extract-rspack-plugin
export default {"danger":"MilestoneDescription-module__danger__nccI5","subtle":"MilestoneDescription-module__subtle__PRcar"};